// removed by extract-text-webpack-plugin
module.exports = {"proxy":"_1l9j0X86hr-HXFww","overlay":"_1KC1p727wgx7uoDY"};


//////////////////
// WEBPACK FOOTER
// ./src/bundles/common/components/serp_photo_gallery/serp_photo_gallery.css
// module id = 753
// module chunks = 0